import { useEffect } from "react";

// Set by vite.config.ts at build time: "YYYY-MM-DD HH:mm" (build machine's local time).
declare const __OC_BUILD_TIME__: string;

const OC_BANNER_HEIGHT = 24;

/**
 * True on the production domain (onboardconnectapp.com, or onboardconnect.com)
 * — anywhere else (pages.dev, workers.dev, localhost) is Stage.
 */
function ocIsProductionHost(host: string): boolean {
  const h = host.toLowerCase();
  return ["onboardconnectapp.com", "onboardconnect.com"].some((d) => h === d || h.endsWith(`.${d}`));
}

/**
 * "STAGE ENVIRONMENT · 2026-10-01 10:53" fixed at the bottom of every page
 * off the production domain, so Stage is never mistaken for Production. The
 * time is when this build was made — it tells you which deploy you're on.
 */
export function OcEnvironmentBanner() {
  const show = typeof window !== "undefined" && !ocIsProductionHost(window.location.hostname);
  useEffect(() => {
    if (!show) return;
    // Keep page content clear of the banner.
    const prev = document.body.style.paddingBottom;
    document.body.style.paddingBottom = `${OC_BANNER_HEIGHT}px`;
    return () => { document.body.style.paddingBottom = prev; };
  }, [show]);
  if (!show) return null;
  const built = typeof __OC_BUILD_TIME__ === "string" ? __OC_BUILD_TIME__ : "";
  return (
    <div
      role="status"
      aria-label={`Stage environment${built ? `, built ${built}` : ""}`}
      style={{ height: OC_BANNER_HEIGHT }}
      className="fixed inset-x-0 bottom-0 z-[60] flex items-center justify-center gap-2 bg-amber-400 dark:bg-amber-500 text-[11px] font-bold uppercase tracking-[0.12em] text-amber-950 border-t border-amber-500 dark:border-amber-600 select-none pointer-events-none"
    >
      <span>Stage Environment</span>
      {built && <span aria-hidden="true">·</span>}
      {built && <span className="font-mono normal-case tracking-normal">{built}</span>}
    </div>
  );
}
